import type { FC } from 'react'

import { FilterTabs } from '@skytech/ui/FilterTabs'
import { getEntries } from '@skytech/utils'

import { Translation } from '@/app/translations/Translation'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import type { TradeInOrderCounter } from '@/modules/admin/resources'

export const StatusTabs: FC<{ orderCounter: TradeInOrderCounter }> = ({ orderCounter }) => {
  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status', 'PRICE_REQUEST')

  return (
    <FilterTabs className="hidden overflow-x-auto md:flex">
      {getEntries(orderCounter).map(([orderStatus, counter]) => (
        <FilterTabs.Button
          className="flex items-center justify-center gap-1 whitespace-normal break-words"
          filterName={<Translation id={`trade_in_order_status/${orderStatus}`} />}
          isSelected={orderStatus === queryStatus}
          counter={counter}
          key={orderStatus}
          onClick={() => setQueryStatus(orderStatus)}
        />
      ))}
    </FilterTabs>
  )
}
